"use client";

import classNames from "classnames";

import { Link } from "@components/Link";

import "./styles.scss";
import NextImage from "@/utils/__mocks__/next/image";

interface I_Logo {
  responsive?: boolean;
  href?: string;
  src: string;
  siteName: string;
  width: number;
  height: number;
  dataQa?: string;
  dataTestId?: string;
  className?: string;
  setSource?: (event: string) => void;
  loading?: "eager" | "lazy";
  quality?: number;
}

export const Logo = ({
  responsive = false,
  href,
  src,
  siteName,
  width,
  height,
  dataQa = "logo-data-qa",
  dataTestId = "logo-data-testid",
  className,
  setSource,
  loading = "lazy",
  quality,
}: I_Logo) => {
  const classes = classNames("main-logo", {
    "main-logo--responsive": responsive,
    [className]: className,
  });

  return (
    <div
      className={classes}
      data-qa={dataQa}
      data-testid={dataTestId}
    >
      <WithLink
        href={href}
        siteName={siteName}
        setSource={setSource}
      >
        <NextImage
          src={src}
          width={width}
          height={height}
          loading={loading}
          alt={`${siteName} logo`}
          quality={quality}
        />
      </WithLink>
    </div>
  );
};

const WithLink = ({ href, siteName, children, setSource }) => {
  if (!href) {
    return children;
  }

  return (
    <Link
      aria-label={`${siteName} logo`}
      href={href}
      onClick={() => setSource && setSource("")}
    >
      {children}
    </Link>
  );
};
